import { useFormContext } from "react-hook-form";
import DataProtection from "../../lawandorder/DataProtection.tsx";
import PopUp, { openModal } from "../../core/PopUp.tsx";
import Nutzungsbedingung from "../../lawandorder/Nutzungsbedingung.tsx";
import { IconCheck, IconX } from "@tabler/icons-react";
import Toggle from "../../core/Toggle.tsx";

const ConfirmInput = ({ requiredText }: { requiredText: string }) => {
  const { register, formState } = useFormContext();

  return (
    <div className="flex items-center gap-2 rounded-full bg-base-100 p-2 mb-2 ">
      <PopUp id={"data-protection"} title="Datenschutzerklärung">
        <DataProtection />
      </PopUp>
      <PopUp id={"user-agreement"} title="Nutzungsbedingung">
        <Nutzungsbedingung />
      </PopUp>
      <Toggle validatorHint={requiredText} isError={!!formState.errors.ack}>
        <input
          type="checkbox"
          {...register("ack", {
            required: requiredText,
            validate: (v: boolean) => v || "Bitte hier",
          })}
        />
        <IconX aria-label="disabled" />
        <IconCheck aria-label="enabled" />
      </Toggle>
      <p className="text-base-content">
        Ich bin mindestens 18 Jahre alt, stimme der{" "}
        <button
          onClick={() => openModal("data-protection")}
          className="link"
          type="button"
        >
          Datenschutzerklärung
        </button>{" "}
        und den{" "}
        <button
          onClick={() => openModal("user-agreement")}
          className="link"
          type="button"
        >
          Nutzungsbedingungen
        </button>{" "}
        zu.
      </p>
    </div>
  );
};
export default ConfirmInput;
